<template>
  <label class="FormField" @change="checkInvalid" @input="checkValid" :class="status">
    <div class="title">{{ title }}</div>
    <textarea v-if="rows"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="input"
      v-bind="{ rows, placeholder, disabled }"
    ></textarea>
    <input v-else
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      class="input"
      v-bind="{ placeholder, disabled }"
    >
    <div class="errorMessage" :hidden="status !== 'invalid'">{{ errorMessage }}</div>
  </label>
</template>

<script>
export default {
  props: {
    checkInvalid: Function,
    checkValid: Function,
    status: String,
    title: String,
    placeholder: String,
    modelValue: String,
    disabled: Boolean,
    errorMessage: String,
    rows: Number,
  },
}
</script>

<style scoped>

.title {
  font-weight: 600;
  font-size: var(--font-size-2);
  color: var(--text-color-black);
}

.input {
  display: block;
  width: 100%;
  border: thin solid #e9e9e9;
  border-radius: 8px;
  padding: var(--spacing-3) var(--spacing-4);
  background-color: #f9f9f9;
}

textarea.input {
  resize: none;
}

.FormField.invalid .input {
  border-color: #d00;
}

.input::placeholder {
  color: #8c8c8c;
}

.errorMessage {
  font-weight: 400;
  font-size: var(--font-size-2);
  color: #d00;
}

.title + .input {
  margin-top: 0.25rem;
}

.input + .errorMessage {
  margin-top: 0.25rem;
}

.input:disabled {
  opacity: 0.25;
}
</style>
